import { useEffect, useState } from 'react';

const currencyCodes = [
    "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN",
    "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL",
    "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHF", "CLP", "CNY",
    "COP", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP",
    "ERN", "ETB", "EUR", "FJD", "FKP", "FOK", "GBP", "GEL", "GGP", "GHS",
    "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF",
    "IDR", "ILS", "IMP", "INR", "IQD", "IRR", "ISK", "JEP", "JMD", "JOD",
    "JPY", "KES", "KGS", "KHR", "KID", "KMF", "KRW", "KWD", "KYD", "KZT",
    "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD",
    "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN",
    "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK",
    "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR",
    "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD",
    "SSP", "STN", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY",
    "TTD", "TVD", "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VES",
    "VND", "VUV", "WST", "XAF", "XCD", "XOF", "XPF", "YER", "ZAR", "ZMW",
    "ZWL"
];

export default function CurrencyForm() {
    const [amount, setAmount] = useState(0);
    const [fromCountry, setFromCountry] = useState('USD');
    const [toCountry, setToCountry] = useState('INR');
    const [convertedAmount, setConvertedAmount] = useState(0);
    const [exchangeData, setExchangeData] = useState([]);

    let disable = true;
    let checkValue;
    let selectedFlag;

    const handleSwap = () => {
        setFromCountry(toCountry);
        setToCountry(fromCountry);
    }

    const exchangeDataList = (list) => {
        setExchangeData((exchangeData) => [...exchangeData, list])
    }

    const convertCurrencyAPI = async () => {
        if (amount === 0) return;
        const API_KEY = "4a8e5f7c836cfd15e28a0502";
        const API_URL = `https://v6.exchangerate-api.com/v6/${API_KEY}/pair/${fromCountry}/${toCountry}`;

        try {
            const response = await fetch(API_URL);
            if (!response) throw Error("Something wen wrong");
            const data = await response.json();
            const rate = (amount * data.conversion_rate).toFixed(2);
            setConvertedAmount(rate);

            const exchangeList = { fromCountry: fromCountry, toCountry: toCountry, totalAmount: amount, exchangeValue: rate }
            exchangeDataList(exchangeList);

        }
        catch (err) {
            console.log(err);
        }
    }

    // useEffect(() => convertCurrencyAPI, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        convertCurrencyAPI()
    }

    return <>
        <form onSubmit={handleSubmit} className='form-box'>
            <div className='currency-box'>
                <label>From</label>
                <CurrencySelect
                    checkValue={amount}
                    onSetAmount={setAmount}
                    currencyType={fromCountry}
                    onSetCurrencyType={setFromCountry}
                    selectedFlag={fromCountry.slice(0, 2)}
                />
            </div>
            <button className='swap-box' onClick={handleSwap}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className='swap-svg'><path d="M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z" /></svg>
            </button>
            <div className='currency-box'>
                <label>To</label>
                <CurrencySelect
                    disable={disable}
                    currencyType={toCountry}
                    onSetCurrencyType={setToCountry}
                    checkValue={convertedAmount}
                    selectedFlag={toCountry.slice(0, 2)}
                />
            </div>
            <button className='exchange-btn'>Exchange</button>
        </form>
        <div className='exchange-list-box'>
            <h2>Converted List</h2>
            <div className='table-list'>
                <table cellpadding="0" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th width="130">From</th>
                            <th width="130">To</th>
                            <th>Amount</th>
                            <th>Exchange</th>
                        </tr>
                    </thead>
                    <tbody>
                        {exchangeData.reverse().map((exchange) =>
                            <tr key={exchange}>
                                <td><img src={`https://flagsapi.com/${exchange.fromCountry.slice(0, 2)}/flat/64.png`} alt='Currency Icon' className='flag-icon' />{exchange.fromCountry}</td>
                                <td><img src={`https://flagsapi.com/${exchange.toCountry.slice(0, 2)}/flat/64.png`} alt='Currency Icon' className='flag-icon' />{exchange.toCountry}</td>
                                <td><b>{exchange.totalAmount}</b></td>
                                <td><span className='value-btn'>{exchange.exchangeValue}</span></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    </>
}

function CurrencySelect({ checkValue, onSetAmount, disable, currencyType, onSetCurrencyType, selectedFlag }) {

    return <div className='from-exchange'>
        <div className='amount-box'>
            <input type='number' value={checkValue} onChange={(e) => onSetAmount(e.target.value)} disabled={disable} />
        </div>
        <div className='currecny-data'>
            <img src={`https://flagsapi.com/${selectedFlag}/flat/64.png`} alt='Currency Icon' />
            <select value={currencyType} onChange={(e) => onSetCurrencyType(e.target.value)}>
                {currencyCodes.map((currency) => <option key={currency} value={currency}>{currency}</option>)}
            </select>
        </div>
    </div>
}